/* Granite City Graphics redesign: small behaviours for gcg-* sections */
(function () {
  function initHero(root) {
    root.querySelectorAll('.gcg-hero').forEach(function (hero) {
      if (hero.dataset.gcgInit) return;
      hero.dataset.gcgInit = '1';
      requestAnimationFrame(function () { hero.classList.add('is-ready'); });
    });
  }

  function initServices(root) {
    root.querySelectorAll('[data-gcg-services]').forEach(function (wrap) {
      if (wrap.dataset.gcgInit) return;
      wrap.dataset.gcgInit = '1';
      var items = wrap.querySelectorAll('.gcg-svc');
      var imgs = wrap.querySelectorAll('.gcg-services__stage img');
      function activate(i) {
        items.forEach(function (el, n) { el.classList.toggle('is-active', n === i); });
        imgs.forEach(function (el) { el.classList.toggle('is-active', Number(el.dataset.index) === i); });
      }
      items.forEach(function (el, i) {
        el.addEventListener('mouseenter', function () { activate(i); });
        el.addEventListener('focusin', function () { activate(i); });
      });
      if (items.length) activate(0);
    });
  }

  function initShade(root) {
    root.querySelectorAll('[data-gcg-shade]').forEach(function (wrap) {
      if (wrap.dataset.gcgInit) return;
      wrap.dataset.gcgInit = '1';
      var film = wrap.querySelector('.gcg-shade__film');
      var label = wrap.querySelector('.gcg-shade__label');
      wrap.querySelectorAll('input[type="radio"]').forEach(function (input) {
        input.addEventListener('change', function () {
          film.style.setProperty('--film', input.dataset.film);
          label.textContent = input.dataset.label;
        });
      });
    });
  }

  function initTabs(root) {
    root.querySelectorAll('[data-gcg-tabs]').forEach(function (wrap) {
      if (wrap.dataset.gcgInit) return;
      wrap.dataset.gcgInit = '1';
      var tabs = Array.prototype.slice.call(wrap.querySelectorAll('[role="tab"]'));
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) tab.focus();
      }
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tab, false); });
        tab.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
            e.preventDefault();
            var next = (i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
            select(tabs[next], true);
          }
        });
      });
    });
  }

  function init(root) {
    root = root || document;
    initHero(root); initServices(root); initShade(root); initTabs(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();


/* Mobile fix: shrink the Yuko Rewards launcher to a small icon on phones so it doesn't cover buttons */
(function(){if(window.__gcgYukoFix)return;window.__gcgYukoFix=true;var css="@media (max-width: 749px){#yuko-launcher-button{padding:0!important;width:44px!important;height:44px!important;min-width:0!important;border-radius:50%!important;display:flex!important;align-items:center!important;justify-content:center!important;left:12px!important;bottom:12px!important}#yuko-launcher-button .yuko-launcher-button-text{display:none!important}#yuko-launcher-button .yuko-launcher-button-icon{margin:0!important}}";function apply(){var h=document.getElementById("yuko-launcher-widget");if(!h||!h.shadowRoot)return false;if(h.shadowRoot.getElementById("gcg-yuko-fix"))return true;var s=document.createElement("style");s.id="gcg-yuko-fix";s.textContent=css;h.shadowRoot.appendChild(s);return true;}var n=0,t=setInterval(function(){if(apply()||++n>60)clearInterval(t);},250);})();